import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { LoanSimulation } from "../../interfaces/LoanSimulation";

import { LoanSimulationContextType } from "./loan-context.types";

const loanData = sessionStorage.getItem("CEX-LoanSimulation");

const initialState: LoanSimulationContextType = {
  loanSimulation: JSON.parse(loanData as string) || null,

  setLoanSimulation: () => {},
};

export const LoanContext = createContext(initialState);

export const LoanContextProvider: React.FC<PropsType> = ({ children }) => {
  const [loanSimulation, setLoanSimulation] = useState<LoanSimulation | null>(initialState.loanSimulation);

  useEffect(() => {
    if (loanSimulation) {
      sessionStorage.setItem('CEX-LoanSimulation', JSON.stringify(loanSimulation))
    }
  }, [loanSimulation])

  return (
    <LoanContext.Provider value={{ loanSimulation, setLoanSimulation }}>
      {children}
    </LoanContext.Provider>
  );
};
